export default {"src":"/_next/static/media/error-dot.54308879.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};